/*
 * This module implements TosRUs media plugin to show YouTube videos.
 *
 * The built-in YouTube media plugin from TosRUs has some problems:
 *   - It hard codes http URLs which makes it not work on https pages
 *   - It uses an undocumented postMessage() protocol used internally by the
 *     YouTube player JS api.
 *   - It uses the protocol incorrectly, leading to it breaking the video by
 *     pausing a stopped video. This is potentially a bug in the YouTube player
 *     itself though.
 */

import $ from 'jquery';

import { tosrus, BaseTosRUsMediaPlugin } from './tosrus';
import {
    getYouTubePlayerApi, YOUTUBE_STATE_PLAYING, YOUTUBE_STATE_BUFFERING
} from './youtube-player-api';

const MEDIA = 've-youtube',
      DEFAULT_OPTIONS = {
          ratio: 16 / 9
      };

export class YouTubeJsApiTosRUsMediaPlugin extends BaseTosRUsMediaPlugin {

    init() {
        super.init();

        this.tos.data.add('ratio');
    }

    filterAnchors(tosInstance, $anchor) {
        let a = $anchor.get(0);
        return (/^(?:www\.)youtube.com$/i).test(a.host) &&
               /^\/watch$/.test(a.pathname) &&
               (/[?&]v=[^&]+/).test(a.search);
    }

    getYouTypeId(href) {
        let query = $('<a>').attr('href', href).prop('search');
        let id = query.replace(/[?&]v=([^&]+)(?:$|&)/, '$1');
        return id ? decodeURIComponent(id) : null;
    }

    initAnchors(tosInstance, $slide, href) {
        let $anchor = $slide.data(this.tos.data.anchor);
        let id = this.getYouTypeId(href);
        // Create a placeholder element to be replaced by the YouTube JS API.
        let $placeholder = $('<div class="tosrus-youtube-player-placeholder">')
            .appendTo($slide);

        this.initVideo(tosInstance, $slide, $placeholder, id);
    }

    getVideoSize($slide, ratio) {
        let w = $slide.width();
        let h = $slide.height();

        if(ratio > (w / h))
            return [w, w / ratio];
        else
            return [h * ratio, h];
    }

    initVideo(tosInstance, $slide, $placeholder, id) {
        let $anchor = $slide.data(this.tos.data.anchor) || $();
        let ratio = $anchor.data(this.tos.data.ratio) ||
                    tosInstance.opts[MEDIA].ratio;

        getYouTubePlayerApi().then(YT => {
            let [w, h] = this.getVideoSize($slide, ratio);

            let player = new YT.Player($placeholder.get(0), {
                videoId: id,
                width: w,
                height: h
            });

            let $iframe = $(player.getIframe());

            $slide.removeClass(this.tos.classes.loading)
                .trigger(this.tos.events.loaded)
                .on(this.tos.events.loading, () => {
                    this.tos.funcs.resizeRatio($iframe, $slide,
                                               null, null, ratio);
                });

            tosInstance.nodes.$wrpr
                .on(this.tos.events.sliding, () => {
                    // Pausing a stopped video breaks the video, so we have
                    // to ensure it needs pausing first.
                    let state = player.getPlayerState();

                    if(state === YOUTUBE_STATE_PLAYING ||
                        state === YOUTUBE_STATE_BUFFERING) {
                        player.pauseVideo();
                    }
                })
                .on(this.tos.events.closing, () => {
                    player.stopVideo();
                });

            this.tos.globals.$wndw.on(this.tos.events.resize, () => {
                this.tos.funcs.resizeRatio($iframe, $slide, null, null, ratio);
            });
        });
    }
}

export function register() {
    tosrus.media[MEDIA] = new YouTubeJsApiTosRUsMediaPlugin();
    tosrus.defaults.media[MEDIA] = {};
    tosrus.defaults[MEDIA] = DEFAULT_OPTIONS;
}



/** WEBPACK FOOTER **
 ** ./js/view/components/lightbox/tosrus.ve-youtube.js
 **/